import axios from 'axios';
import http from './http-common';
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory';

const validateMyInfoData = (sId) => {
    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken(),
            Pragma: 'no-cache'  //IE11
        }
    }

    let stateId;
    if (sId) {
        stateId = sId;
    }
    else {
        stateId = storage.getStateId();
    }
    
    //return http.get(`http://localhost:3000/Validate.json`);
    return http.get(`/api/v1/SMEDL/Validate/${stateId}`,headerParams); 
}

const verificationForm = (params) => {
    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }

   // return http.get(`http://localhost:3000/VerificationResData.json`);
   return http.post(`/api/v1/SMEDL/VerificationForm`, params, headerParams)
}

const submitformData = (params) => {
    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }

    return http.post(`/api/v1/SMEDL/postLoanRequestForm`, params, headerParams);
}


const updateformData = (params) => {
    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }

    return http.put(`/api/v1/SMEDL/putLoanRequestForm`, params, headerParams);
}

const getformdata = (reffernceNo) => {
    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }
    // console.log('Auth:',"Maybank" + " " + storage.getToken());
    // return http.get(`http://localhost:3000/FinanceDtls.json`);
    return http.get(`/api/v1/SMEDL/getLoanRequestForm/` + reffernceNo, headerParams);
};


//Address Api 
const getAddressApiUrl = () => {
    let addressApiUrl = '';
    switch (config.SERVER_STATUS) {
        case "DEV": addressApiUrl = config.AddressApi.DEV
            break;
        case "SIT": addressApiUrl = config.AddressApi.SIT
            break;
        case "UAT": addressApiUrl = config.AddressApi.UAT
            break;
        case "PROD": addressApiUrl = config.AddressApi.PROD
            break;
        case "SIM": addressApiUrl = config.AddressApi.SIM
            break;
        default:
            break;
    }
    return addressApiUrl;
};

const getSecurityApiUrl = () => {
    let apiUrl = '';
    switch (config.SERVER_STATUS) {
        case "DEV": apiUrl = config.SmeApi.DEV
            break;
        case "SIT": apiUrl = config.SmeApi.SIT
            break;
        case "UAT": apiUrl = config.SmeApi.UAT
            break;
        case "PROD": apiUrl = config.SmeApi.PROD
            break;
        case "SIM": apiUrl = config.SmeApi.SIM
            break;
        default:
            break;
    }
    return apiUrl;
}

const getAddress = data => {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': storage.getToken()
    }
    
  // return axios.get('http://localhost:3000/Address.json');
 
    return axios.get(getAddressApiUrl()+'/'+data);
}

const security = () => {

    // let params = { appId: "SMEDigital" };  //will change to this when henry api has changed
    
    // let params = { appId: "myinfopackageIW7cL4iFE5kf" }; //existing

    let params = { appID: "myinfopackageIW7cL4iFE5kf89ksaxdascsatwaaswdweyd"} //after .net migration

    const headers = {
        'Content-Type': 'application/json'
    }
    let url = getSecurityApiUrl() + '/api/Security'
    return axios.post(url, params, headers);
}


const getMainConfig = (url) => {
    return axios.get(url);
}

const preKnockout = (status) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
      
    let stateId = storage.getStateId();
   
    
    return http.get(`/api/v1/SMEDL/PreQualificationknockout/${stateId}/${status}`,headerParams);
}

const saveAndContinue = (params) => {

    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
  
    return http.put(`/api/v1/SMEDL/PutSaveandContinue`,params,headerParams);
}

const postRecaptcha = (secretKey, captchaValue) => {
    let url = 'https://www.google.com/recaptcha/api/siteverify';
    let params = {
        secret: secretKey,
        response:captchaValue
    }

    const headers = {
        'Content-Type': 'application/json'
    }
  
    
    return axios.post(`https://www.google.com/recaptcha/api/siteverify?secret=${secretKey}&response=${captchaValue}`, params, headers);
}


const getNonLending = (refNo) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
    
    return http.get(`/api/v1/SMEDL/GetLendingSolution/${refNo}`,headerParams);
}

const postNonLending = (params) => {
    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }

    return http.post(`/api/v1/SMEDL/LendingSolutions`, params, headerParams);
}

const uploadDocument = (file, rno, fName, fDocsType,fId,loginUserIC) => {
 
    const fData = new FormData();
    fData.append('files', file);
    
    let headerParams ={
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': "Maybank" + " " + storage.getToken()
          }
    }
    return http.post(`/api/v1/SMEDL/PostDocumentUpload/${rno}/${fDocsType}/${fId}/${loginUserIC}`, fData, headerParams);
}

const deleteDocument = (params) => {

    let headerParams = {
        headers: {
            "Content-Type": "application/json",
            'Authorization': "Maybank" + " " + storage.getToken()
        }
    }

    return http.put(`/api/v1/SMEDL/DeleteDocumentUpload`, params, headerParams);
}

const getAllDocument = (rno) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
    
    return http.get(`/api/v1/SMEDL/${rno}`,headerParams);
}

const getPdfFileUrl = (rno,desc,id) => {
  
    let baseApiUrl = '';
    switch (config.SERVER_STATUS) {
        case "DEV": baseApiUrl = config.SmeApi.DEV
        break;
      case "SIT": baseApiUrl = config.SmeApi.SIT 
        break;
      case "UAT": baseApiUrl = config.SmeApi.UAT 
        break;
      case "PROD": baseApiUrl = config.SmeApi.PROD 
        break;
      case "SIM": baseApiUrl = config.SmeApi.SIM 
        break;
      default:
        break;
    }
   
    const url = baseApiUrl+`/api/v1/SMEDL/GetDocumentUploadPDF/${rno}/${desc}/${id}`;
    
    return url;
  }

const getDocument = (rno,fDocsType,fId) => {
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
    
    return http.get(`/api/v1/SMEDL/${rno}/${fDocsType}/${fId}`,headerParams);
}

export default {
    getAddress,
    getMainConfig,
    security,
    verificationForm,
    // creatState,
    submitformData,
    updateformData,
    getformdata,
    validateMyInfoData,
    preKnockout,
    saveAndContinue,
    postRecaptcha,
    postNonLending,
    getNonLending,
    uploadDocument,
    getAllDocument,
    getDocument,
    getPdfFileUrl,
    deleteDocument
};